import * as actionTypes from "./action-types"


export const totalScore=()=>{
    return {
        type:actionTypes.TOTALSCORE
    }
}

export const contentAfterLogin=()=>{
    return {
        type:actionTypes.CONTENTAFTERLOGIN
    }
}
export const afterLogout=()=>{
    return {
        type:actionTypes.AFTERLOGOUT
    }
}